// extracted by mini-css-extract-plugin
module.exports = {"intro":"Dashboard_intro__Ry7PL","subHead":"Dashboard_subHead__3EOQU","presentation":"Dashboard_presentation__2OoAG"};